import { Input } from "@/components/ui/input";
import { Loader2, Lock } from "lucide-react";
import { Logo } from "@/components/Brand";

export const AdminGate = ({
  title,
  subtitle,
  value,
  onChange,
  onSubmit,
  loading = false,
  error = "",
  gateTestId,
  inputTestId,
  errorTestId,
  buttonTestId,
}) => (
  <div className="flex min-h-screen items-center justify-center bg-[#0B132B] px-6" data-testid={gateTestId}>
    <form
      onSubmit={onSubmit}
      className="w-full max-w-[400px] rounded-3xl border border-white/10 bg-[#14213D] p-8 text-center shadow-[0_12px_40px_rgba(0,0,0,0.35)]"
    >
      <div className="flex justify-center">
        <Logo imgClass="h-10" />
      </div>
      <div className="mx-auto mt-7 flex h-11 w-11 items-center justify-center rounded-xl bg-[#F5A623]/15">
        <Lock className="h-5 w-5 text-[#F5A623]" />
      </div>
      <h1 className="mt-4 font-heading text-2xl font-extrabold text-white">{title}</h1>
      <p className="mt-2 text-sm leading-relaxed text-[#9FB2C9]">{subtitle}</p>
      <Input
        type="password"
        value={value}
        onChange={onChange}
        placeholder="Admin key"
        data-testid={inputTestId}
        className="mt-6 h-12 rounded-xl border-white/15 bg-[#0B132B] text-white placeholder:text-[#6E829B] focus-visible:ring-[#F5A623]"
        autoFocus
      />
      {error && (
        <p className="mt-3 text-sm font-medium text-[#FF8A8A]" data-testid={errorTestId}>
          {error}
        </p>
      )}
      <button
        type="submit"
        disabled={loading}
        data-testid={buttonTestId}
        className="mt-5 inline-flex w-full items-center justify-center gap-2 rounded-xl bg-[#F5A623] py-3 font-heading text-base font-bold text-[#0B132B] transition-transform duration-200 hover:-translate-y-0.5 disabled:opacity-70"
      >
        {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Unlock"}
      </button>
    </form>
  </div>
);
